import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Category.module.sass';
import Button from '../../../ui_kit/button/Button';
import BackButton from '../back_button/BackButton';
import CategoryBlock from './category_block/CategoryBlock';
import mobileSkincareIcon from '../../../../images/pages/quiz/categories/mobile_skincare.svg';
import mobileBodyIcon from '../../../../images/pages/quiz/categories/mobile_body.svg';
import mobileHairIcon from '../../../../images/pages/quiz/categories/mobile_hair.svg';
import mobileMakeupIcon from '../../../../images/pages/quiz/categories/mobile_makeup.svg';
import mobileOtherIcon from '../../../../images/pages/quiz/categories/mobile_other.svg';
import mobileTechIcon from '../../../../images/pages/quiz/categories/mobile_tech.svg';
import desktopSkincareIcon from '../../../../images/pages/quiz/categories/desktop_skincare.svg';
import desktopMakeupIcon from '../../../../images/pages/quiz/categories/desktop_makeup.svg';
import desktopHairIcon from '../../../../images/pages/quiz/categories/desktop_hair.svg';
import desktopBodyIcon from '../../../../images/pages/quiz/categories/desktop_body.svg';
import desktopTechIcon from '../../../../images/pages/quiz/categories/desktop_tech.svg';
import desktopOtherIcon from '../../../../images/pages/quiz/categories/desktop_other.svg';
import CATEGORIES from '../../constants/categories';

function Category(props) {
  const { increaseStep, decreaseStep, quiz } = props;

  const [category, setCategory] = useState(quiz.category);
  const [customCategory, setCustomCategory] = useState(
    Object.values(CATEGORIES).includes(category) ? '' : category || '',
  );

  let updatedQuiz = { ...quiz, category };
  if (quiz.category !== category) {
    updatedQuiz = {
      ...updatedQuiz,
      productType: '',
      uniqueIngredient: '',
      application: '',
      lookAndFeel: '',
      shades: '',
      whatMakesItSpecial: '',
      concerns: [],
    };
  }

  const onNextClick = () => {
    increaseStep(updatedQuiz);
  };

  const setCategories = (updatedCategory) => {
    setCategory(updatedCategory);
    setCustomCategory(updatedCategory);
  };

  return (
    <>
      <BackButton
        decreaseStep={() => {
          decreaseStep(updatedQuiz);
        }}
      />
      <div className={styles.category}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            Which category does your beauty wonder fit under?
          </h1>
          <div className={styles.categories}>
            <div className={styles.row}>
              <CategoryBlock
                setCategory={setCategory}
                selectedCategory={category}
                category={CATEGORIES.SKINCARE}
                mobileImage={mobileSkincareIcon}
                desktopImage={desktopSkincareIcon}
              />
              <CategoryBlock
                setCategory={setCategory}
                selectedCategory={category}
                category={CATEGORIES.MAKEUP}
                mobileImage={mobileMakeupIcon}
                desktopImage={desktopMakeupIcon}
              />
              <CategoryBlock
                setCategory={setCategory}
                selectedCategory={category}
                category={CATEGORIES.HAIR}
                mobileImage={mobileHairIcon}
                desktopImage={desktopHairIcon}
              />
            </div>
            <div className={styles.row}>
              <CategoryBlock
                setCategory={setCategory}
                selectedCategory={category}
                category={CATEGORIES.TECH}
                mobileImage={mobileTechIcon}
                desktopImage={desktopTechIcon}
              />
              <CategoryBlock
                setCategory={setCategory}
                selectedCategory={category}
                category={CATEGORIES.BODY}
                mobileImage={mobileBodyIcon}
                desktopImage={desktopBodyIcon}
              />
              <CategoryBlock
                setCategory={setCategories}
                selectedCategory={category}
                category={customCategory}
                mobileImage={mobileOtherIcon}
                desktopImage={desktopOtherIcon}
                editable
              />
            </div>
          </div>
          <Button
            className={styles.button}
            onClickHandler={onNextClick}
            disabled={!category}
            text="NEXT"
            color="transparent-blue"
            size="small"
          />
        </div>
      </div>
    </>
  );
}

Category.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    category: PropTypes.string,
    productType: PropTypes.string,
  }).isRequired,
};

export default Category;
